import { render, staticRenderFns } from "./ECommerceClean.vue?vue&type=template&id=b490449e&scoped=true&"
import script from "./ECommerceClean.vue?vue&type=script&lang=js&"
export * from "./ECommerceClean.vue?vue&type=script&lang=js&"
import style0 from "./ECommerceClean.vue?vue&type=style&index=0&id=b490449e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b490449e",
  null
  
)

export default component.exports